import { render, staticRenderFns } from "./DiplomaSave.vue?vue&type=template&id=5da78137&"
import script from "./DiplomaSave.vue?vue&type=script&lang=js&"
export * from "./DiplomaSave.vue?vue&type=script&lang=js&"
import style0 from "./DiplomaSave.vue?vue&type=style&index=0&id=5da78137&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports